'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
		return Number.isNaN;
	}
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-nan/polyfill.js
// module id = 78
// module chunks = 22433821621997 31167082146650 235131596041995